import { useMutation, useQueryClient } from "react-query";
import {
  cancelExpenseRecurrence,
  createBulkExpense,
  createExpense,
  createExpenseDepartment,
  deleteExpenseDepartment,
  updateExpense,
  updateExpenseDepartment,
} from "../../../services/expenses";
import { updateExpenseCategory } from "../../../services/expenses";

export const useCreateExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createExpense(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
    },
  });
};

export const useUpdateExpense = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateExpense(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
      queryClient.invalidateQueries(["getExpenseDetails", id]);
    },
  });
};

export const useCancelExpenseRecurrenceMutation = ({ id } = {}) => {
  const queryClient = useQueryClient();
  return useMutation((id) => cancelExpenseRecurrence(id), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
      queryClient.invalidateQueries(["getExpenseDetails", id]);
    },
  });
};

// Custom hook to update an expense's category
export const useUpdateExpenseCategory = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateExpenseCategory(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
    },
  });
};

export const useCreateBulkExpenseMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createBulkExpense(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenses"]);
    },
  });
};

export const useCreateExpenseDepartmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createExpenseDepartment(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenseDepartments"]);
    },
  });
};

export const useUpdateExpenseDepartmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateExpenseDepartment(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenseDepartments"]);
    },
  });
};

export const useDeleteExpenseDepartmentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => deleteExpenseDepartment(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getExpenseDepartments"]);
    },
  });
};
